import EditOperation from "./edit-operation";

export default EditOperation;